const viewGroups = [
  {
    text: 'Worklist',
    items: [
      {
        id: '1',
        text: 'Assigned to me',
        selected: true,
        count: 3
      }
    ]
  },
  {
    text: 'Work groups',
    items: [
      {
        id: '2',
        text: 'Underwriting',
        selected: false,
        count: 8
      },
      {
        id: '3',
        text: 'Escalations',
        selected: false,
        count: 1
      }
    ]
  },
  {
    text: 'Team members',
    items: [
      {
        id: '4',
        text: 'James Kirk',
        selected: false,
        visual: { name: 'James Kirk' },
        count: 5
      },
      {
        id: '5',
        text: 'Leonard McCoy',
        selected: false,
        visual: { name: 'Leonard McCoy' },
        count: 4
      }
    ]
  }
];

export default viewGroups;
